var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, spacing } from './theme';
export var StyledBaseButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: ", ";\n  color: ", ";\n  font-family: 'Open Sans', Arial, Helvetica, sans-serif;\n  font-size: ", "px;\n  font-weight: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n"], ["\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: ", ";\n  color: ", ";\n  font-family: 'Open Sans', Arial, Helvetica, sans-serif;\n  font-size: ", "px;\n  font-weight: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var color = _a.color;
    return colors[color] || undefined;
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize ? fontSizes[fontSize] : fontSizes.regular;
}, function (_a) {
    var _b;
    var fontWeight = _a.fontWeight;
    return (_b = fontWeights[fontWeight]) !== null && _b !== void 0 ? _b : fontWeights.bold;
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign !== null && textAlign !== void 0 ? textAlign : 'center';
}, function (_a) {
    var uppercase = _a.uppercase;
    return (uppercase ? 'uppercase' : undefined);
});
export var StyledPrimaryButton = styled(StyledBaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", "px ", "px;\n  background-color: ", ";\n  border: 0;\n  border-radius: 4px;\n  color: ", ";\n  text-transform: uppercase;\n\n  @media ", " {\n    width: 100%;\n  }\n"], ["\n  padding: ", "px ", "px;\n  background-color: ", ";\n  border: 0;\n  border-radius: 4px;\n  color: ", ";\n  text-transform: uppercase;\n\n  @media ", " {\n    width: 100%;\n  }\n"])), spacing.base, spacing.large, function (_a) {
    var disabled = _a.disabled;
    return disabled ? colors.grey : colors.cyanBlue;
}, colors.white, mediaQueries.lessThanMedium);
var templateObject_1, templateObject_2;
